import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import { Card } from 'antd';
import Title from 'antd/es/typography/Title';

interface ProjectsByStateBarPlotProps {
  data: {
    actualisé: number;
    "non visité": number;
    // "partiellement actualisé": number;
    "à actualiser": number;
  };
}

const ProjectsByStateBarPlot: React.FC<ProjectsByStateBarPlotProps> = ({ data }) => {
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (chartRef.current) {
      const chart = echarts.init(chartRef.current);

      const option = {
       
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        
        xAxis: {
          type: 'category',
          data: ['Actualisé', 'Non Visité', 'À Actualiser'],
          axisLabel: {
            rotate: 45,
            margin: 20,
          },
        },
        yAxis: {
          type: 'value',
          interval: 50, // Force ticks to increment by 1
          axisLabel: {
            formatter: (value: number) => Math.floor(value).toString(), // Ensure whole numbers
          },
        },
        series: [
          {
            name: 'Projets',
            type: 'bar',
            barWidth: '50%', // Adjust the width of the bars
            data: [
              data.actualisé,
              data["non visité"],
              // data["partiellement actualisé"],
              data["à actualiser"],
            ],
            itemStyle: {
              borderRadius: [10, 10, 0, 0],
              color: (params: any) => {
                const colors = ['#87d068', '#f50','#e0a333'];
                return colors[params.dataIndex];
              },
            },
          },
        ],
      };

      chart.setOption(option);

      const resizeHandler = () => {
        chart.resize();
      };

      window.addEventListener('resize', resizeHandler);

      return () => {
        window.removeEventListener('resize', resizeHandler);
        chart.dispose();
      };
    }
  }, [data]);

  return (
    <Card style={{border: '2px solid #42005a',marginBottom: '20px'}}>
      <Title  level={5} style={{ width: "100%",textAlign: "center" }}>Projets par statut</Title>
      <div ref={chartRef} style={{ height: '240px', width: '100%' }}></div>
    </Card>
  );
};

export default ProjectsByStateBarPlot;